<div class="modal-backdrop" (click)="onCancel()"></div>
<div class="modal">
  <div class="modal-header">
    <h3>{{ 'providers.delete_dialog_title' | translate }}</h3>
  </div>
  <div class="modal-body">
    <p>
      {{ 'providers.delete_dialog_message' | translate:{ providerType: provider?.ProviderType || '' } }}
    </p>
  </div>
  <div class="modal-footer">
    <button class="button secondary" type="button" (click)="onCancel()" [disabled]="submitting">
      {{ 'providers.cancel' | translate }}
    </button>
    <button class="button danger" type="button" (click)="onConfirm()" [disabled]="submitting">
      {{ 'providers.delete' | translate }}
    </button>
  </div>
</div>
